var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56717 12.2116C11.1847 10.6224 11.0098 7.8741 9.17667 6.07304C7.34351 4.27197 4.54621 4.1002 2.92872 5.68937C1.31123 7.27855 1.48607 10.0269 3.31922 11.828C5.15238 13.629 7.94968 13.8008 9.56717 12.2116Z",
    fill: "#EDBFDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4658 8.68126C18.9058 8.68126 20.8838 6.7379 20.8838 4.34063C20.8838 1.94337 18.9058 0 16.4658 0C14.0258 0 12.0479 1.94337 12.0479 4.34063C12.0479 6.7379 14.0258 8.68126 16.4658 8.68126Z",
    fill: "#EDBFDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6147 8.68126C31.0547 8.68126 33.0327 6.7379 33.0327 4.34063C33.0327 1.94337 31.0547 0 28.6147 0C26.1748 0 24.1968 1.94337 24.1968 4.34063C24.1968 6.7379 26.1748 8.68126 28.6147 8.68126Z",
    fill: "#EDBFDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9457 13.1029C42.6326 11.371 42.7069 8.75092 41.1115 7.25094C39.5161 5.75096 36.8553 5.93904 35.1683 7.67103C33.4813 9.40301 33.4071 12.023 35.0024 13.523C36.5978 15.023 39.2587 14.8349 40.9457 13.1029Z",
    fill: "#EDBFDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638 10.0811C21.7453 9.87495 21.0605 9.92921 20.4862 10.2439C16.753 12.2514 8.72334 14.1071 6.53645 25.5446C6.18301 27.4003 5.17793 30.341 6.53645 33.4337C7.90602 36.5264 11.341 39.4564 14.533 39.0657C17.8685 38.6533 18.7411 35.6692 21.9772 35.8102C25.8761 35.973 25.2907 39.0657 30.537 39.0657C34.4138 39.0657 38.2906 32.8912 38.5336 27.8018C38.8649 20.835 32.503 13.5645 22.3638 10.092V10.0811Z",
    fill: "#EDBFDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/Shop.350fc6b28c426152ed3e3118383f591b.svg";
export { ForwardRef as ReactComponent };